import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SelectionSummary from './SelectionSummary';
import MapSummary from './MapSummary';
import palette from '../../../styles/palette';

const SelectionPanel = ({ quote, children }) => {
  const [quoteData, setQuoteData] = useState(null);

  useEffect(() => {
    setQuoteData(quote.result);
  }, [quote]);

  const styles = {
    panel: {
      maxHeight: '55vh',
    },
    box: {
      backgroundColor: palette.white,
      border: `1px solid ${palette.gt_grey_light_5}`,
      borderRadius: '6px',
      whiteSpace: 'nowrap',
      overflowX: 'auto',
      padding: '0.5em',
      paddingTop: '0em',
    },
  };

  return (
    <Stack direction="column" spacing={1} sx={styles.panel}>
      <SelectionSummary
        zipCount={quoteData?.total_zipcodes}
        // averageIncome={quoteData?.demographics.avg_hhi_formatted}
        // averageAge={quoteData?.demographics.avg_age}
        // femaleAudience={quoteData?.demographics.gender_female}
        // maleAudience={quoteData?.demographics.gender_male}
        // otherAudience={quoteData?.demographics.gender_other}
      />
      <Box component="div" sx={styles.box}>
        {children}
      </Box>
      <MapSummary
        totalAddresses={quoteData?.demographics.total_households}
        totalCostWithoutDiscount={quoteData?.price_without_discount_formatted}
        totalDiscount={quoteData?.total_discount_formatted}
        totalCost={quoteData?.price_formatted}
        quantityUntilNextDiscount={quoteData?.qty_next_discount_formatted}
      />
    </Stack>
  );
};

export default observer(SelectionPanel);
